import { slave as Gateway } from '@nsftx/seven-gravity-gateway';
import { defaultToAny, isNil, defaultTo, get } from './Utility';
import { registry } from './Registry';
import { ConfigurationErrors, TokenType } from './Types';
export class GravityGatewayAdapter {
    constructor(options) {
        this.options = options;
        if (isNil(this.options.slaveId)) {
            throw new Error(ConfigurationErrors.MissingSlaveIdError);
        }
    }
    getConfiguration() {
        if (Gateway) {
            this.gateway = new Gateway({
                allowedOrigins: this.options.allowedOrigins,
                debug: this.options.isDebug,
                slaveId: this.options.slaveId,
                eventPropagation: this.options.eventPropagation,
                eventListeners: this.options.eventListeners,
                plugins: this.options.plugins,
                load: this.onLoad.bind(this),
            });
            Object.assign(registry.messageProtocols.gravityGateway, {
                handler: this.gateway,
            });
        }
        this.setWebView();
    }
    getUserLocale(user) {
        if (user) {
            if (user.profile) {
                return user.profile.language;
            }
            return user.language;
        }
        return undefined;
    }
    getUserTimezone(user) {
        if (user) {
            if (user.profile) {
                return user.profile.timezone;
            }
            return user.timezone;
        }
        return undefined;
    }
    getCompanyProductId(company) {
        if (company && company.config) {
            return company.config.cpvUuid;
        }
        return undefined;
    }
    getCompanyTimezoneOffset(company) {
        if (company && company.config) {
            return company.config.timezoneOffset;
        }
        return 0;
    }
    parseUser(user) {
        if (user) {
            let accessToken;
            let refreshToken;
            if (user.auth) {
                accessToken = defaultTo(user.auth.accessToken, user.auth.token);
                refreshToken = user.auth.refreshToken;
            }
            return {
                id: defaultTo(user.id, user.uuid),
                username: defaultTo(user.name, user.username),
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                balance: defaultToAny(user.balanceTotal, user.balance, 0),
                token: defaultTo(user.token, accessToken),
                tokenType: TokenType.Bearer,
                timezone: this.getUserTimezone(user),
                refreshToken,
            };
        }
        return user;
    }
    setWebView() {
        const webViewHandler = (action, payload) => {
            const cleanMessage = JSON.stringify(payload);
            const message = JSON.parse(cleanMessage);
            this.onLoad(message);
        };
        Object.assign(window, {
            onParentMessage: webViewHandler,
        });
    }
    onLoad(message) {
        const payload = message.data;
        const betslip = defaultTo(get(payload, 'betslip'), undefined);
        const company = defaultToAny(get(payload, 'company'), get(payload, 'tenant'), {});
        const product = defaultToAny(get(payload, 'product'), get(payload, 'account'), {});
        const user = defaultTo(get(payload, 'user'), undefined);
        const channel = defaultTo(get(payload, 'dp'), undefined);
        const betshop = defaultTo(get(payload, 'betshop'), {});
        const device = defaultToAny(get(payload, 'device'), betshop.device, {});
        const integration = defaultTo(get(payload, 'integration'), undefined);
        const language = defaultTo(get(payload, 'locale'), {});
        const settings = defaultTo(get(payload, 'settings'), {});
        const scrollButtons = defaultTo(get(settings, 'scrollButtons'), undefined);
        const moneyDenominations = defaultTo(get(settings, 'moneyDenominations'), undefined);
        const showCursor = defaultTo(get(settings, 'showCursor'), undefined);
        const environment = defaultToAny(payload.environment, payload.env, undefined);
        const platformName = registry.platforms.seven.name;
        const platformDataCenter = defaultToAny(payload.platformDataCenter, payload.platformDc, undefined);
        const productName = defaultToAny(product.id, undefined);
        const productId = defaultToAny(product.cpvUuid, product.linkId, this.getCompanyProductId(company), undefined);
        const productUuid = defaultToAny(product.uuid, undefined);
        const tenantId = defaultToAny(company.uuid, company.id, undefined);
        const locale = defaultToAny(language.iso1, payload.language, company.language, this.getUserLocale(user), undefined);
        const applicationName = defaultToAny(payload.applicationName, payload.appName, payload.app, undefined);
        const channelId = defaultToAny(channel, undefined);
        const betshopId = defaultToAny(betshop.uuid, undefined);
        const deviceId = defaultToAny(device.uuid, undefined);
        const isIntegration = defaultToAny(integration, undefined);
        const event = new CustomEvent('Configuration:SetConfiguration', {
            detail: {
                environment,
                platformName,
                platformDataCenter,
                productName,
                productId,
                productUuid,
                tenantId,
                locale,
                applicationName,
                channelId,
                betshopId,
                deviceId,
                isIntegration,
                betslip,
                scrollButtons,
                moneyDenominations,
                showCursor,
                user: this.parseUser(user),
            },
        });
        window.dispatchEvent(event);
    }
}
//# sourceMappingURL=GravityGatewayAdapter.js.map